import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
//@ts-ignore
import LogEngine from "@eait/logengine-client"
//do not use @elastic/eui/dist/eui_theme_light.min.css or @elastic/eui/dist/eui_theme_dark.min.css with sass files
import "@elastic/eui/src/theme_light.scss"
import "./customStyles.sass"
import moment from "moment"
import { htmlIdGenerator } from "@elastic/eui"
import { CORRELATION_ID_KEY } from "./constants/common"

//@ts-ignore
LogEngine.Setup(window.Configs.LOG_ENGINE_APP_ID)

const prefix = `${moment.utc().format("YYYY_MM_DD")}ID`
localStorage.setItem(CORRELATION_ID_KEY, htmlIdGenerator(prefix)())

ReactDOM.render(<App />, document.getElementById("root"))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
